import { CoreContext } from 'context/CoreContext'
import React, { useContext, useEffect } from 'react'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import useI18n from 'hooks/useI18n'
import { ModalContainer as CoreModalContainer, Overlay } from 'ui/styled'
import {
  EmptyDescription,
  EmptyState,
  EmptyTitle,
  ModalContainer,
  PreviewBody,
  PreviewFrame,
  ModalContent, PreviewHeader, PreviewMeta, PreviewImage, PreviewVideo
} from './styled'

export default function ModalPdfPreview() {
  const { modal, setModal } = useContext(CoreContext)

  const { t } = useI18n()
  useEffect(() => {
    const onKey = (event) => { if (event.key === 'Escape') setModal(null) }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [setModal])

  const close = () => setModal(null)
  const handleClose = (e) => {
    const mc = document.getElementById('pdf-preview-modal-content')
    if (!mc?.contains(e?.target) && !(e?.target?.tagName === 'LI')) {
      close()
    }
  }

  return (
    <Overlay onClick={handleClose}>
      <CoreModalContainer>
        <ModalContent id='pdf-preview-modal-content' role='dialog' aria-modal='true' aria-label={modal?.title}>
          <PreviewHeader>
            <PreviewMeta><span title={modal?.title}>{modal?.title}</span></PreviewMeta>
            {modal?.downloadUrl ? <a href={modal.downloadUrl} download>{t('search.download')}</a> : null}
            <IconButton aria-label={t('close')} onClick={close}><CloseIcon /></IconButton>
          </PreviewHeader>
          <ModalContainer>
            {modal?.url ? (
              <>
                <PreviewBody>
                  {modal.type === 'image-preview' ? <PreviewImage src={modal.url} alt={modal?.title || ''} /> : modal.type === 'video-preview' ? <PreviewVideo src={modal.url} controls playsInline preload='metadata' aria-label={modal?.title} /> : <PreviewFrame src={modal.url} title={modal?.title || 'PDF preview'} />}
                </PreviewBody>
              </>
            ) : (
              <EmptyState>
                <EmptyTitle>Unable to load PDF preview.</EmptyTitle>
                <EmptyDescription>Please close and try opening this file again.</EmptyDescription>
              </EmptyState>
            )}
          </ModalContainer>
        </ModalContent>
      </CoreModalContainer>
    </Overlay>
  )
}
